import clsx from "clsx";
import React from "react";
import {
  MenuProps,
  MenuItem,
  ListItemText,
  Tooltip,
  Box,
  ListItemIcon,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { Menu } from "./Menu";

const useStyles = makeStyles((theme) => ({
  root: {
    "& svg": {
      width: theme.spacing(2),
      height: theme.spacing(2),
      color: theme.palette.text.primary,
    },
  },

  tooltip: {
    padding: theme.spacing(1, 2),
  },

  reactive: {},
}));

export interface ListMenuOption {
  label: React.ReactNode;
  onClick: (event: React.MouseEvent<HTMLLIElement, MouseEvent>) => void;
  disabled?: boolean;
  tooltipText?: string;
  icon?: React.ReactNode;
}

export interface ListMenuProps extends MenuProps {
  disabled?: boolean;
  options: ListMenuOption[];
}

export function ListMenu(props: ListMenuProps) {
  const { className, onClose, disabled, options, ...other } = props;
  const s = useStyles();

  return (
    <Menu
      MenuListProps={{ dense: true }}
      onClose={onClose}
      className={clsx(s.root, className)}
      {...other}
    >
      {options.map(
        (
          { label, onClick, disabled: optionDisabled, tooltipText, icon },
          index,
        ) => {
          const itemDisabled = disabled || optionDisabled;
          const item = (
            <MenuItem
              className={clsx(itemDisabled && tooltipText && s.reactive)}
              onClick={itemDisabled ? undefined : onClick}
              disabled={itemDisabled}
              dense
            >
              {icon && <ListItemIcon children={icon} />}

              <ListItemText primary={label} />
            </MenuItem>
          );

          return (
            // Box because Menu does not accept fragments for children
            <Box key={index}>
              {tooltipText ? (
                <Tooltip
                  arrow
                  placement="right"
                  className={s.tooltip}
                  title={tooltipText}
                  children={item}
                />
              ) : (
                item
              )}
            </Box>
          );
        },
      )}
    </Menu>
  );
}
